import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradebookSyncReport from "./routes/GradebookSyncReport";

export default store => ({
  path: "dashboard",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebooksync" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [GradebookSyncReport(store)],
});
